<template>
  <div>
    <el-date-picker
      v-model="data"
      type="datetimerange"
      :picker-options="pickerOptions"
      range-separator="-"
      :start-placeholder="placeholder[0]"
      :end-placeholder="placeholder[1]"
      align="right"
      @input="change($event)">
    </el-date-picker>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: null,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  props: ['value', 'placeholder', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      if (val) {
        let date = []
        let date1 = val[0]
        let date2 = val[1]
        date[0] = date1.getFullYear() + '/' + (date1.getMonth() + 1) +
          '/' + date1.getDate() + ' ' + this.addzero(date1.getHours()) +
          ':' + this.addzero(date1.getMinutes()) + ':' + this.addzero(date1.getSeconds())
        date[1] = date2.getFullYear() + '/' + (date2.getMonth() + 1) +
          '/' + date2.getDate() + ' ' + this.addzero(date2.getHours()) +
          ':' + this.addzero(date2.getMinutes()) + ':' + this.addzero(date2.getSeconds())
        this.$emit('input', date)
        this.data = date
      } else {
        this.$emit('input', val)
      }
    },
    addzero: function (obj) {
      if (obj < 10) {
        return '0' + obj
      } else {
        return obj
      }
    }
  },
  mounted () {
    let arr = this.value
    if (arr) {
      for (let j = 0, len = arr.length; j < len; j++) {
        arr[j] = arr[j].replace(/-/g, '/')
      }
    }
    this.data = arr
    if (!this.placeholder) {
      this.placeholder = ['开始日期', '结束日期']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/DateTimePicker.vue